export default __webpack_public_path__ + "static/media/sabinestroh1.5508c567.jpg";